import type { IFormxRepository } from '../repositories/IFormxRepository.js';
import type { FormxFormEntity } from '../entities/FormxEntity.js';

interface Deps { formxRepository: IFormxRepository; }

export function createGetFormxFormUseCase({ formxRepository }: Deps) {
  return async function getFormxForm(id: string): Promise<FormxFormEntity | null> {
    return formxRepository.getForm(id);
  };
}
